<div class="cs-cb-atom">
  <div class="electron"></div>
  <div class="electron-alpha"></div>
  <div class="electron-omega"></div>
</div>

<style lang="scss">
  @use './../../../../scss/components/themes/loading-theme/loading-atom-theme';
</style>
